/**
 * Утилита для формирования полного URL изображения
 */

/**
 * Получить базовый URL изображения с автоматической оптимизацией
 * Теперь бэкенд автоматически возвращает оптимизированные изображения,
 * но мы можем добавить параметры для дополнительной оптимизации
 */
export const getImageUrl = (imagePath, width = null, format = null) => {
  if (!imagePath) return '/placeholder.jpg'
  
  // Если уже полный URL
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    // Если URL уже содержит параметры оптимизации, возвращаем как есть
    // Иначе можем добавить параметры для дополнительной оптимизации
    if (width || format) {
      const url = new URL(imagePath)
      if (width) url.searchParams.set('w', width)
      if (format) url.searchParams.set('format', format)
      return url.toString()
    }
    return imagePath
  }
  
  // Формируем полный URL
  const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000'
  // Убираем /api/v1 если есть в baseUrl
  const cleanBaseUrl = baseUrl.replace(/\/api\/v1$/, '')
  
  let url = `${cleanBaseUrl}${imagePath}`
  
  // Добавляем параметры для оптимизации
  const params = new URLSearchParams()
  if (width) {
    params.append('w', width)
  }
  if (format) {
    params.append('format', format)
  }
  if (params.toString()) {
    url += (url.includes('?') ? '&' : '?') + params.toString()
  }
  
  return url
}

/**
 * Генерировать srcset для responsive images
 * Создает набор URL для разных размеров экрана
 * WebP не используется по умолчанию, так как файлы могут не существовать
 */
export const getImageSrcSet = (imagePath, sizes = [400, 600, 800, 1200, 1600], useWebP = false) => {
  if (!imagePath) return ''
  
  // Используем только JPEG, так как WebP файлы могут не существовать
  // WebP будет добавлен через <source> в OptimizedImage, если поддерживается браузером
  return sizes
    .map((size) => {
      return `${getImageUrl(imagePath, size, null)} ${size}w`
    })
    .join(', ')
}

/**
 * Получить sizes атрибут для responsive images
 * Определяет размер изображения в зависимости от размера экрана
 */
export const getImageSizes = (customSizes = null) => {
  if (customSizes) return customSizes
  
  // Дефолтные sizes для адаптивности
  return '(max-width: 640px) 100vw, (max-width: 1024px) 50vw, (max-width: 1280px) 33vw, 25vw'
}

/**
 * Получить оптимальный размер изображения для конкретного контейнера
 */
export const getOptimalImageSize = (containerWidth, devicePixelRatio = 1) => {
  // Учитываем pixel ratio для Retina дисплеев
  const optimalWidth = Math.ceil(containerWidth * devicePixelRatio)
  
  // Округляем до ближайшего стандартного размера
  const sizes = [400, 600, 800, 1000, 1200, 1600, 2000]
  return sizes.find(size => size >= optimalWidth) || sizes[sizes.length - 1]
}
